import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from '../Reports/ReportCard';
import { PREDICTION_TYPES } from './predictionTypes';

/**
 * Group header + 2-up (1-up under 640px) grid of the two prediction type
 * cards. Reuses ReportCard verbatim — it only needs {id,title,subtitle,
 * module,Icon}, which predictionTypes.js already provides in that shape.
 */
function PredictionTypeCards({ selectedId, onSelect }) {
	return (
		<section className='tw:mb-6'>
			<div className='tw:mb-3 tw:flex tw:items-baseline tw:gap-1.5'>
				<h3 className='tw:m-0 tw:text-[12px] tw:font-semibold tw:uppercase tw:tracking-[0.06em] tw:text-ink-2'>
					Tipo de previsión
				</h3>
				<span className='tw:text-[12px] tw:text-ink-3'>· Egresos o ingresos proyectados</span>
			</div>
			<div className='tw:grid tw:grid-cols-1 tw:gap-2.5 tw:min-[640px]:grid-cols-2'>
				{PREDICTION_TYPES.map((type) => (
					<ReportCard
						key={type.id}
						report={type}
						selected={type.id === selectedId}
						onSelect={onSelect}
					/>
				))}
			</div>
		</section>
	);
}

PredictionTypeCards.propTypes = {
	selectedId: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
};

export default PredictionTypeCards;
